import * as React from "react";
import { Row, Col, InputNumber } from "antd";

interface TimeSelecterState {
	sec: number;
	min: number;
	hour: number;
	days: number;
	totalseconds: number;
}

interface TimeSelecterProps {
	time: number;
	mode: ControlMode;
	onChanged: (val: number) => void;
}

export default class TimeSelecter extends React.Component<TimeSelecterProps, TimeSelecterState> {
	public state: TimeSelecterState = {
		sec: 0,
		min: 0,
		hour: 0,
		days: 0,
		totalseconds: 0,
	}

	public componentDidMount() {

		const { time } = this.props;
		const timetostr = '';
		const sec = time % 60;
		const min = Math.round(time / 60) % 60;
		const hour = Math.round(time / 3600) % 24;
		const days = Math.round(time / (3600 * 24));
		this.setState({
			min,
			sec,
			days,
			hour,
			totalseconds: time,
		});
	}

	public render() {
		const { min, sec, days, hour, totalseconds } = this.state;
		const mode = this.props.mode;
		//timetostr = days + ' d' + hour + " h" + min + " m" + sec + "s"

		return (
			<Row >
				<Col span={6}>
					<label > Days</label>
					<InputNumber min={0} max={999999999} value={days} onChange={this.onDaysChange} disabled={mode == 'display'} />
				</Col>
				<Col span={6}>
					<label > Hours</label>
					<InputNumber min={0} max={999999999} value={hour} onChange={this.onHoursChange} disabled={mode == 'display'} />
				</Col>
				<Col span={6}>
					<label > Min</label>
					<InputNumber min={0} max={999999999} value={min} onChange={this.onMinutesChange} disabled={mode == 'display'} />
				</Col>
				<Col span={6}>
					<label > Sec</label>
					<InputNumber min={0} max={999999999} value={sec} onChange={this.onSecondsChange} disabled={mode == 'display'} />
				</Col>
			</Row>
		);
	}

	private onDaysChange = (newVal: number) => {
		const totalseconds = this.state.sec + 60 * this.state.min + this.state.hour * 3600 + newVal * 3600 * 24;
		this.setState({ days: newVal, totalseconds });
		this.props.onChanged(totalseconds)
	}

	private onHoursChange = (newVal: number) => {
		const totalseconds = this.state.sec + 60 * this.state.min + newVal * 3600 + this.state.days * 3600 * 24;
		this.setState({ hour: newVal, totalseconds });
		this.props.onChanged(totalseconds)
	}

	private onMinutesChange = (newVal: number) => {
		const totalseconds = this.state.sec + 60 * newVal + this.state.hour * 3600 + this.state.days * 3600 * 24;
		this.setState({ min: newVal, totalseconds });
		this.props.onChanged(totalseconds)
	}

	private onSecondsChange = (newVal: number) => {
		const totalseconds = newVal + 60 * this.state.min + this.state.hour * 3600 + this.state.days * 3600 * 24;
		this.setState({ sec: newVal, totalseconds });
		this.props.onChanged(totalseconds)
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/form/timeselecter.tsx